import { getBuilderCanvasDocument } from "@/lib/canvas/helpers";

/**
 * Only blurs if the element is actually focused to avoid unnecessary operations.
 */
export function blurContentEditableElement(): void {
  const doc = getBuilderCanvasDocument();
  if (!doc) return;

  const activeElement = doc.activeElement;
  if (!activeElement) return;

  if (activeElement.getAttribute("contenteditable") === "true") {
    (activeElement as HTMLElement).blur();
  }
}
